import en from './en/';
import pt from './pt/';
import ptBr from './pt_br/';
import es from './es/';

const messages = {
  en: en,
  pt: pt,
  pt_br: ptBr,
  es: es
}

export default messages;
